<template>
  <div ref="enterList">
    <div class="form-group">
      <textarea :placeholder="placeholder" class="form-control" v-model="input"></textarea>
    </div>
    <div class="text-right">
      <button class="btn btn-primary" @click="handleEnterList">追加する</button>
    </div>
    <entry-error
      v-if="failedCount > 0"
      :eventCode="eventCodeDownload"
      :total="total"
      :failedCount="failedCount"
    />
  </div>
</template>

<script>
import EntryError from './SaleEntryError'
import SaleService from '@/services/salemasterservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    EntryError
  },
  data () {
    return {
      loader: null,
      input: null,
      placeholder: `以下の形式でASINのみを改行して入力してください
B08ABC0001
B08ABC0002
B08ABC0003
      `,
      total: 0,
      failedCount: 0
    }
  },
  computed: {
    saleId () {
      return this.$route.params.saleId
    },
    asins () {
      return this.input
        .split(/\r?\n/)
        .map(line => line.trim())
        .filter(line => line)
    },
    eventCodeDownload () {
      return eventCode.sale.entry.list_input.download_report
    }
  },
  methods: {
    loading () {
      this.loader = this.$loading.show({
        container: this.$refs.enterList,
        backgroundColor: 'rgba(255,255,255,0.7)',
        canCancel: false,
        width: 40,
        height: 40,
        zIndex: 1000
      })
    },
    async handleEnterList () {
      if (this.asins.length === 0) {
        return false
      }

      const logParams = {
        name: eventCode.sale.entry.list_input.add,
        properties: {
          saleId: this.saleId
        }
      }
      EventService.postTrackLog(logParams)

      this.loading()
      const params = {
        saleId: this.saleId,
        asins: this.asins
      }
      await SaleService.inputSaleEntry(params)
        .then((response) => {
          if (response.data.passAsins.length > 0) {
            this.$emit('setAddedAsins', response.data.passAsins)
            this.input = ''
          }
          this.total = response.data.total
          this.failedCount = response.data.failedCount
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    }
  }
}
</script>
<style scoped>
textarea {
  width: 100%;
  height: 300px;
  resize: none;
  overflow: auto;
  padding: 8px;
  font-size: 14px;
  line-height: 1.5;
  border: 1px solid #ccc;
  border-radius: 4px;
}

textarea::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

textarea::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 3px;
}

textarea::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}

textarea {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
}

</style>



// WEBPACK FOOTER //
// src/view/sale/components/SaleEntryInputList.vue